export const SET_ROLE_CLIENTS_LOADED = "SET_ROLE_CLIENTS_LOADED";

export const setRoleClientsLoaded = (roleClientsLoaded: boolean) => {
  return {
    roleClientsLoaded,
    type: SET_ROLE_CLIENTS_LOADED
  };
};
